import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import AddItemModal from "./addItem";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import DocumentsComponent from "./luxaryAssetsComponent/documentsComponent";
import PictureComponent from "./luxaryAssetsComponent/pictureCompoenent";
import MovementComponent from "./luxaryAssetsComponent/movementComponent";
import JournalComponent from "./luxaryAssetsComponent/journalComponent";
import LegacyComponent from "./luxaryAssetsComponent/legacyComponent";
import { formatNumber, truncateText } from "../../../../../utility/helper";
import {
  deleteMediaService,
  deleteTransaction,
  getFutureTransaction,
  getUserAssets,
} from "../../../../../services/transaction";
import { filterDropdownOptions } from "../../../../../utility/data";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  addMediaService,
  getItemsService,
  getJournalService,
  getLegaciesService,
  getLuxaryTransaction,
  getMediaService,
} from "../../../../../services/legacy/legacyApi";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const dropdownOptions = [
    { name: "ADD ITEM" },
    { name: "EXPENSE" },
    { name: "INCOME" },
    { name: "SELL" },
    { name: "VALUATION" },
  ];
  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [filterType, setFilterType] = useState(filterDropdownOptions[0]);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [legaciesData, setLegaciesData] = useState([]);

  const [addItems, setAddItems] = useState([]);
  const [items, setItems] = useState("");
  const [journalData, setJournalData] = useState([]);

  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Pictures");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const selectedAsset = useSelector((state) => state.userAssets.selectedAsset);
  const location = useLocation();
  const id = location?.state?.id || null;
  const sell = viewTransaction?.transactions?.find(
    (item) => item.type === "SELL"
  );

  useEffect(() => {
    if (selectedAsset && items) {
      GetTransactionData();
      GetJournalData();
      GetLegaciesData();
    }
  }, [selectedAsset, items, filterType, page]);

  useEffect(() => {
    if (selectedAsset) {
      GetAddedItemData();
    }
  }, [selectedAsset]);

  useEffect(() => {
    if (
      (selectedButton === "Pictures" || selectedButton === "Documents") &&
      items
    ) {
      GetMediaData();
    }
  }, [selectedButton, selectedAsset, filterType, page, items]);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 4, selectedAssetId: id }));
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetMediaData = async () => {
    const mediaType = selectedButton === "Pictures" ? "image" : "file";
    setLoading(true);
    try {
      const response = await getMediaService(
        selectedAsset?.id,
        items.id,
        mediaType,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetAddedItemData = async () => {
    setLoading(true);
    try {
      const response = await getItemsService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setAddItems(data);
        if (data.length > 0) {
          setItems(data[0]);
        } else {
          setItems(null);
        }
      } else {
        throw new Error("Failed to fetch items data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetJournalData = async () => {
    setLoading(true);
    try {
      const response = await getJournalService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setJournalData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetLegaciesData = async () => {
    setLoading(true);
    try {
      const response = await getLegaciesService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setLegaciesData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getLuxaryTransaction(
        selectedAsset?.id,
        items.id,
        page * limit,
        limit,
        filterType,
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFutureTransaction(
        selectedAsset?.id,
        page,
        limit,
        filterType,
        3,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        fetchUserAssets();
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleMediaDelete = async (media_id, fileType) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        fetchUserAssets();
        GetTransactionData();
        // GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: `${fileType ? fileType : "Media"} deleted successfully`,
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    const mediaType = selectedButton === "Pictures" ? "image" : "file";
    if (selectedButton === "Documents") {
      setMediaLoading(true);
    }
    if (!items?.id) {
      setMediaData([]);
      setMediaLoading(false);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: "Please add a Luxuary item first before uploading any file.",
        life: 2000,
      });
      return;
    }

    try {
      const response = await addMediaService(
        media,
        selectedAsset?.id,
        items.id,
        mediaType,
        accessToken
      );
      if (response) {
        GetMediaData();
        GetTransactionData();
        GetJournalData();
        GetLegaciesData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: `${mediaType} upload successfully`,
          life: 3000,
        });
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      if (selectedButton === "Documents") {
        setMediaLoading(false);
      }
    }
  };

  const confirmMediaDelete = (mediaId, fileType) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${
        fileType ? fileType : "Media"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleMediaDelete(mediaId, fileType),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "bg-primary hover:border-white text-gray-300 font-bold py-2 px-4 rounded border border-[rgb(161,147,147)]",
      confirmClass:
        "bg-secondary hover:bg-gray-400 font-bold py-2 px-4 rounded ml-4 text-primary border",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div
        className={`relative ${
          mediaLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        <div className="text-gray-400">
          <CustomDropdown
            options={userAssets}
            name={selectedAsset?.name || "Select Asset"}
            assetId={selectedAsset?.id || null}
            onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
            returnFullObject={true}
            truncateText={truncateText}
            size={19}
            className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md hover:border hover:border-secondary"
          />
        </div>
        {selectedButton === "Journal" ? (
          <div className="grid md:grid-cols-3 grid-cols-4">
            <div className="md:col-span-3 col-span-4 text-sm">
              <div className="grid md:grid-cols-3 grid-cols-4 gap-1">
                <div className="ml-1 break-words">
                  {selectedAsset?.name ?? ""}
                </div>
                <div className="ml-1 break-words text-center border-b text-3xl mt-[-21px] border-gray-500">
                  Journal
                </div>
                <div
                  className={` text-2xl mt-[-16px] justify-around flex gap-5 ${
                    Number(journalData?.total_roi ?? 0) * 100 < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  <div className="text-end">ROI</div>
                  <span>
                    {formatNumber(
                      (Number(journalData?.total_roi ?? 0) * 100).toFixed(2)
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="grid md:grid-cols-12 grid-cols-4">
            <div className="md:col-span-2 col-span-4 text-sm">
              <div className="grid md:grid-cols-2 grid-cols-4 gap-1">
                <div className="ml-1" title={selectedAsset?.name ?? "house1"}>
                  {(selectedAsset?.name ?? "").length > 10
                    ? (selectedAsset?.name ?? "").substring(0, 10) + "..."
                    : selectedAsset?.name ?? ""}
                </div>
                <div className="flex justify-around whitespace-nowrap font-bold ml-3">
                  <span className="ml-4 mr-3">CHF</span>
                  <span>
                    {formatNumber(
                      Number(viewTransaction?.valuation) !== 0
                        ? Number(viewTransaction?.valuation ?? 0).toFixed(2)
                        : Number(viewTransaction?.initial_balance ?? 0).toFixed(
                            2
                          )
                    )}
                  </span>
                </div>
              </div>
              <div className="grid md:grid-cols-2 grid-cols-4 gap-1 mt-2">
                <div className="text-gray-400">
                  <CustomDropdown
                    options={addItems}
                    name={items ? items.name : "Select Items"}
                    assetId={items ? items.id : "Select Items"}
                    onOptionSelect={(option) => {
                      setItems(option);
                    }}
                    returnFullObject={true}
                    truncateText={truncateText}
                    size={19}
                    className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md hover:border hover:border-secondary"
                  />
                </div>
              </div>
            </div>

            <div className="md:col-span-9 col-span-4 text-end whitespace-nowrap text-[0.70rem]">
              <div className="grid md:grid-cols-5 grid-cols-4 gap-2 font-bold">
                <div className="text-sm ml-7">
                  <span
                    className={`mr-5 ${
                      Number(viewTransaction?.crr ?? 0) < 0 &&
                      Number(viewTransaction?.roi ?? 0) < 0
                        ? "text-expense"
                        : "text-secondary"
                    }`}
                  >
                    CHF
                  </span>
                  <span
                    className={`${
                      Number(viewTransaction?.crr ?? 0) < 0 &&
                      Number(viewTransaction?.roi ?? 0) < 0
                        ? "text-expense"
                        : "text-secondary"
                    }`}
                  >
                    {formatNumber(Number(viewTransaction?.crr ?? 0).toFixed(2))}
                  </span>
                  <span
                    className={`ml-10 ${
                      Number(viewTransaction?.crr ?? 0) < 0 &&
                      Number(viewTransaction?.roi ?? 0) < 0
                        ? "text-expense"
                        : "text-secondary"
                    }`}
                  >
                    {formatNumber(Number(viewTransaction?.roi ?? 0).toFixed(2))}
                    %
                  </span>
                </div>

                <div className="">Realised profit</div>
                <div
                  className={`ml-16 flex justify-between gap-5 ${
                    Number(viewTransaction?.realized ?? 0) < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  <span className="">CHF</span>
                  <span className="">
                    {formatNumber(
                      Number(viewTransaction?.realized ?? 0).toFixed(2)
                    )}
                  </span>
                </div>

                <div className="">INCOME</div>
                <div className="text-secondary ml-16 flex justify-between gap-5">
                  <span className="">CHF</span>
                  <span className="">
                    {formatNumber(
                      Number(viewTransaction?.income ?? 0).toFixed(2)
                    )}
                  </span>
                </div>
              </div>
              <div className="grid md:grid-cols-5 grid-cols-4 gap-2 mt-4 font-bold">
                <div className="text-secondary"></div>
                <div className="">Unrealised profit</div>
                <div
                  className={`ml-16 flex justify-between gap-5 ${
                    Number(viewTransaction?.unrealized ?? 0) < 0
                      ? "text-expense"
                      : "text-secondary"
                  }`}
                >
                  <span className="">CHF</span>
                  <span className="">
                    {formatNumber(
                      Number(viewTransaction?.unrealized ?? 0).toFixed(2)
                    )}
                  </span>
                </div>

                <div className="">EXPENSE</div>
                <div className="text-expense ml-16 flex justify-between gap-5">
                  <span className="">CHF</span>
                  <span className="">
                    {formatNumber(
                      Number(viewTransaction?.expense ?? 0).toFixed(2)
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-end">
              <CustomDropdown
                options={dropdownOptions}
                name={""}
                assetId={""}
                icon={<FaPlus />}
                direction={"right"}
                truncateText={truncateText}
                size={19}
                className={`flex items-center justify-center w-12 h-12 rounded-full font-bold bg-secondary text-primary hover:bg-[#148f77]}`}
                onOptionSelect={(option) =>
                  handleOptionSelect(option, "Create", {})
                }
                // disabled={!!sell}
              />
            </div>
          </div>
        )}

        <div className="border-b border-[rgb(35,135,159)] pt-3"></div>
        <div className="grid md:grid-cols-8 grid-cols-4 mt-2">
          {["Pictures", "Documents", "Movements", "Journal", "Legacy"].map(
            (btn) => (
              <button
                key={btn}
                className={
                  selectedButton === btn ? "text-secondary font-bold" : ""
                }
                onClick={() => setSelectedButton(btn)}
              >
                {btn}
              </button>
            )
          )}
        </div>

        <div className="mt-5">
          {selectedButton === "Pictures" && (
            <PictureComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
            />
          )}
          {selectedButton === "Documents" && (
            <DocumentsComponent
              items={items}
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
            />
          )}
          {selectedButton === "Journal" && (
            <JournalComponent journalData={journalData} />
          )}
          {selectedButton === "Legacy" && (
            <LegacyComponent legaciesData={legaciesData} />
          )}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              viewFutureTransaction={viewFutureTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
            />
          )}
        </div>
        {type === "ADD ITEM" ? (
          <AddItemModal
            visible={modalVisible}
            singleTransactionData={singleTransactionData}
            actionTypes={actionTypes}
            fetchTransactionData={GetTransactionData}
            fetchFutureTransactionData={GetFutureTransactionData}
            GetJournalData={GetJournalData}
            GetLegaciesData={GetLegaciesData}
            viewTransaction={viewTransaction}
            onHide={() => {
              setModalVisible(false);
            }}
            SelectType={type}
            toast={toast}
            loading={loading}
            setLoading={setLoading}
            assetName={selectedAsset}
            GetAddedItemData={GetAddedItemData}
          />
        ) : (
          <CreateTransactionModal
            visible={modalVisible}
            singleTransactionData={singleTransactionData}
            actionTypes={actionTypes}
            fetchTransactionData={GetTransactionData}
            fetchFutureTransactionData={GetFutureTransactionData}
            GetJournalData={GetJournalData}
            GetLegaciesData={GetLegaciesData}
            viewTransaction={viewTransaction}
            onHide={() => {
              setModalVisible(false);
            }}
            SelectType={type}
            toast={toast}
            loading={loading}
            setLoading={setLoading}
            assetName={selectedAsset}
            addItems={addItems}
            items={items}
          />
        )}
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner />
        </div>
      )}
    </>
  );
};

export default ViewTransaction;
